import service from '@/store/services/profile-service';

const state = {
  me: null,
  stats: null,
};

const mutations = {
  SET_RESOURCE: (state, me) => {
    state.me = me;
  },

  SET_STATS: (state, stats) => {
    state.stats = stats;
  }
};

const actions = {
  me({commit, dispatch}, params) {
    return service.get(params)
      .then((profile) => {
        commit('SET_RESOURCE', profile.list);
      });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((profile) => {
        commit('SET_RESOURCE', profile);
      });
  },

  stats({commit, dispatch}, params) {
    return service.stats(params)
      .then((profile) => {
        commit('SET_STATS', profile.list);
      });
  },
};

const getters = {
  me: state => state.me,
  stats: state => state.stats,
};

const profile = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default profile;
